<template>
  <div>

    <b-row>
      <b-col>
        <p><em>A complete professional training to interpret any essential oil with logic, relevance, and authenticity — the new language of modern aromatherapy.</em></p>

        <h2><strong>What You'll Receive</strong></h2>
        <ul class="benefits">
          <li>✅ <strong>The 5-Step EO Architecture™ Framework</strong></li>
          <p style="margin-left: 20px;">Learn the full process — from categorising complexity → seeing patterns → finding harmony → revealing therapeutic value → refining with authenticity.</p>
          
          <li>✅ <strong>Self-Paced Core Training (Lifetime Access)</strong></li>
          <p style="margin-left: 20px;">Clear, bite-sized lessons guiding you through the entire C-L-E-A-R system. Start immediately, revisit anytime, and learn completely at your own pace.</p>
          
          <li>✅ <strong>Clarity Clinics (Live Support Sessions)</strong></li>
          <p style="margin-left: 20px;">Join live calls where we decode real oils, answer questions, and refine interpretations together. All new clinics are added to your library automatically.</p>
          
          <li>✅ <strong>Library Space (Ever-Growing Oil Interpretations)</strong></li>
          <p style="margin-left: 20px;">A continuously expanding collection of single-oil case studies showing the framework in action. New examples are added regularly so your practice keeps evolving.</p>
          
          <li>✅ <strong>Dropsmart Access (1 Month Included)</strong></li>
          <p style="margin-left: 20px;">Your personal visual practice tool for charts, chemistry, aroma patterns, and ratios — no chemistry background required.</p>
          
          <li>✅ <strong>The Melani Method™ Reference Collection (100% original material)</strong></li>
          <ul style="margin-left: 20px;">
            <li>• Scent Logic™ Chart — 36 categories mapped to notes & intensity</li>
            <li>• Crossmap Series — therapeutic connections across 10 domains</li>
            <li>• Glossary of EO Properties — 50 core terms translated into professional aromatherapy language</li>
            <li>• Visual PDFs — category maps, patterns, and tools designed to work hand-in-hand with the framework</li>
          </ul>
          
          <li>✅ <strong>Replay Library & Downloadable Materials</strong></li>
          <p style="margin-left: 20px;">All lessons, replays, summaries, cheat sheets, and updates accessible anytime.</p>
          
          <li>✅ <strong>Ongoing Updates</strong></li>
          <p style="margin-left: 20px;">Every new clinic, oil example, and refinement added to your space automatically — no expiration, no additional cost.</p>
        </ul>

        <h2><strong>Special Live Bonuses (Included Only in This Edition)</strong></h2>
        <ul class="benefits">
          <li>✅ <strong>4 Extra Live Sessions</strong></li>
          <ul>
            <li>• <strong>2 Practice & Q&A Clinics:</strong> refine your interpretations after you begin applying the method.</li>
            <li>• <strong>2 Bonus Trainings:</strong></li>
            <ul>
              <li>• Applying EO Architecture patterns to blends for respiratory balance, pain & stress</li>
              <li>• Exploring symbolism — notes, plant parts, and energetics</li>
            </ul>
          </ul>
          
          <li>✅ <strong>Growing Library of EO Interpretations</strong></li>
          <p style="margin-left: 20px;">Watch essential oils decoded step-by-step through the framework — an ever-expanding library you keep access to.</p>
        </ul>

        <h2><strong>Who This Is For</strong></h2>
        <ul class="benefits">
          <li style="margin-left: 20px;">• Aromatherapists and educators who want a <strong>clear, structured way</strong> to understand and explain essential oils.</li>
          <li style="margin-left: 20px;">• Professionals ready to move from collecting data to <strong>interpreting with logic and authenticity</strong>.</li>
          <li style="margin-left: 20px;">• Practitioners seeking a <strong>repeatable framework</strong> they can use every time — across oils, blends, clients, and lessons.</li>
        </ul>

        <h2><strong>100% Satisfaction Guarantee</strong></h2>
        <div class="guarantee-section">
          <div class="guarantee-image">
            <img src="@/assets/images/guarantee-100-satisfaction.png" alt="100% Satisfaction Guarantee" />
          </div>
          <div class="guarantee-text">
            <p><strong>Your understanding matters.</strong></p>
            <p>This workshop is designed to turn complexity into clarity — and you should never walk away feeling confused or unsure.</p>
            <p>If, after completing the core lessons and attending a clinic, the 5 steps still don't make sense, you'll be invited to a private Clarity Clinic for personalised support.</p>
            <p>You have my full commitment to your understanding and satisfaction.</p>
          </div>
        </div>

        <h2><strong>100% Authentic Framework Promise</strong></h2>
        <div class="guarantee-section">
          <div class="guarantee-image">
            <img src="@/assets/images/guarantee-authentic.png" alt="100% Authentic Framework Promise" />
          </div>
          <div class="guarantee-text">
            <p>The <strong>Essential Oil Architecture™ Method</strong> is an original, field-tested framework built from years of research and real-world professional practice.</p>
            <p>Every step, chart, and model you learn is evidence-based and created to raise the standards of modern aromatherapy.</p>
            <p>You're not learning recycled information — you're learning a complete, original system designed, tested, and taught by its founder.</p>
          </div>
        </div>

        <h2><strong>What Happens Next</strong></h2>
        <p><strong>After registering:</strong></p>
        <ul class="benefits">
          <li>• You'll immediately receive access to the core training, the Reference Collection, and the Library Space.</li>
          <li>• Your month of Dropsmart Access begins right away.</li>
          <li>• New Clarity Clinic dates will be emailed to you and added to your student area.</li>
          <li>• All future updates, sessions, and new oil interpretations appear in your library automatically.</li>
        </ul>
        
        <p><strong>Prefer learning at your own pace? Perfect.</strong></p>
        <p>Everything — lessons, replays, tools, and clinics — is ready when you are.</p>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss">

ul.benefits {
  list-style: none;
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.benefits li {
  margin-top: 10px;
  list-style: none;
  line-height: 28px;
  font-size: 18px;
}

.guarantee-section {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin: 20px 0;
  
  .guarantee-image {
    flex-shrink: 0;
    
    img {
      max-width: 150px;
      height: auto;
    }
  }
  
  .guarantee-text {
    flex: 1;
    
    p {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 10px;
      color: #434343;
    }
  }
}

@media (max-width: 768px) {
  .guarantee-section {
    flex-direction: column;
    align-items: center;
    text-align: center;
    
    .guarantee-image {
      margin-bottom: 15px;
      
      img {
        max-width: 120px;
      }
    }
  }
}

h1 {
  color: #df6e96;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 15px;
}

h2 {
  color: #434343;
  font-size: 24px;
  font-weight: 700;
  margin-top: 30px;
  margin-bottom: 15px;
}

p {
  font-size: 16px;
  line-height: 24px;
  color: #434343;
  margin-bottom: 15px;
}

em {
  font-style: italic;
}

strong {
  font-weight: 700;
}
</style>

<script>

export default {
  name: "EOArchitectureWorkshopLeft",
  props: ['routeName'],
}
</script>
